import awards from "../../shared/it.awards";
import branded_quotes from "../../shared/it.branded-quotes";
import verticals from "./it-education-secondary.verticals";
const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};
export default ({ page, strings }) => {
    switch (page) {
        case "it-education-secondary-contact":
            return {
                page,
                helmet: {
                    meta_title: "Contatti | Rosetta Stone",
                    meta_description:
                        "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                    canonical_url: "https://www.rosettastone.it/istruzione-superiore/contatti/",
                    lang: "it"
                },
                ...pageFooter({ strings })
            };
        case "it-education-secondary-home":
            return {
                page,
                helmet: {
                    meta_title: "Apprendimento linguistico online per l'istruzione superiore | Rosetta Stone",
                    meta_description:
                        "Le soluzioni d’apprendimento linguistico Rosetta Stone per la f’istruzione superiore forniscono agli studenti accesso diretto online all’apprendimento dell’inglese e delle lingue parlate nel mondo. ",
                    canonical_url: "https://www.rosettastone.it/istruzione-superiore/",
                    lang: "it"
                },
                ...pageFooter({ strings })
            };
        case "it-education-secondary-dynamic-resources":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "it"
                },
                ...pageFooter({ strings })
            };
        case "it-education-secondary-dynamic-content":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "it"
                },
                ...pageFooter({ strings })
            };
        case "it-education-secondary-404":
            return {
                page,
                helmet: {
                    meta_title: "Sito non trovato | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://www.rosettastone.it/istruzione-superiore/404",
                    lang: "it"
                },
                ...pageFooter({ strings })
            };
        default:
            return null;
    }
};
